import { DBDef_Action } from '@app/pathway-shared';
import { createSearchIntegration } from '@app/styles';
import { resolveEntity } from '@nu-art/thunderstorm-frontend';
import { ModuleFE_Action } from '../../_entity.js';
import { Manager_Action } from '../../ui/_managers/Manager_Action/Manager_Action.js';
import { SearchAddOn_ByTag } from '@app/hcs-frontend/search/index';
import { ModuleFE_Resource, ModuleFE_Tag, ModuleFE_Value, ModuleFE_Variable } from '@app/hcs-frontend';
import { ModuleFE_AdvisorSnippet, ModuleFE_AdvisorWizard } from '@app/advisor-content-frontend/_entity';
const resolveAction = resolveEntity(ModuleFE_Action);
const { WorkHubItem, UtilObject, SearchItem } = createSearchIntegration({
    module: ModuleFE_Action,
    dbDef: DBDef_Action,
    tag: ['Or', 'Order'],
    labelField: 'name',
    modulesToAwait: [ModuleFE_Action, ModuleFE_Resource, ModuleFE_Variable, ModuleFE_Tag, ModuleFE_Value, ModuleFE_AdvisorWizard, ModuleFE_AdvisorSnippet],
    ManagerComponent: Manager_Action,
    entityLabel: 'Action',
    extraAddOnKeys: [SearchAddOn_ByTag.key],
    extraSearchAddOns: {
        [SearchAddOn_ByTag.methodName]: (result) => {
            const item = resolveAction(result.id);
            return item?.tagGroups;
        },
    },
    resultSubtitle: (action) => action?.type,
    resultEntityLabel: (action) => action?.type === 'order' ? 'Order' : 'Workflow',
});
export const WorkHubItem_Action = WorkHubItem;
export const UtilObject_Action = UtilObject;
export const SearchItem_Action = SearchItem;
//# sourceMappingURL=action.js.map